import moment from "moment"

export const formatCreatedAt = (createdAt: string) => {
  return moment(createdAt).format("D MMM")
}
